import React from 'react';
interface PullQuoteProps {
  quote: string;
  className?: string;
}
export function PullQuote({
  quote,
  className = ''
}: PullQuoteProps) {
  return <blockquote className={`my-12 ${className}`} data-id="element-111">
      <div className="border-l-4 border-blue-600 pl-6 py-2" data-id="element-112">
        <p className="text-2xl md:text-3xl font-bold text-gray-900 leading-tight italic" style={{
        fontFamily: 'Playfair Display, serif'
      }} data-id="element-113">
          "{quote}"
        </p>
      </div>
    </blockquote>;
}